import styled, { css } from 'styled-components';

export const Table = styled.table`
  border-collapse: separate;
  border-spacing: 4px;
`;

export const TableHeader = styled.th`
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;

  padding-left: 6px;

  color: #061e2d;
`;

export const CreditsRangeCell = styled.td<{ isCurrent: boolean }>`
  border: 1px solid #d4d4d4;
  border-radius: 2px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;

  padding: 7px 17px 7px 10px;
  min-width: 170px;

  color: #061e2d;
  ${(p) =>
    p.isCurrent &&
    css`
      background: rgba(97, 153, 243, 0.3);
      font-weight: 700;
    `}
`;

export const CreditsRange = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PlanNameColumn = styled.td`
  background: rgba(97, 153, 243, 0.3);

  border: 1px solid #d4d4d4;
  border-radius: 2px;

  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  padding: 6px 10px 0 8px;

  vertical-align: top;

  color: #061e2d;
`;

export const UsageCell = styled.th`
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  padding-left: 5px;

  text-align: center;

  color: #061e2d;

  a {
    color: #061e2d;
    text-decoration: underline;
  }
`;

export const DescriptionText = styled.div`
  font-weight: 400;
  font-size: 11px;
  margin-bottom: 20px;
  width: 280px;

  color: #000000;

  a {
    font-weight: 700;
    color: #000000;
    text-decoration: underline;
  }
`;
